"use strict";

import Vue from 'vue';
import axios from "axios";
import conf from "./config"
import qs from 'qs'

// Full config:  https://github.com/axios/axios#request-config
// axios.defaults.baseURL = process.env.baseURL || process.env.apiUrl || '';
// axios.defaults.headers.common['Authorization'] = AUTH_TOKEN;
// axios.defaults.headers.post['Content-Type'] = 'application/x-www-form-urlencoded';
axios.defaults.withCredentials = true;
let noJSONstrUrl = conf.noJSONstrUrl
let config = {
  baseURL: conf.baseApi,
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  transformRequest(data) {
    return qs.stringify(data, { indices: false });
  }
};

let webconfig = {
  baseURL: conf.webApi,
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  transformRequest(data) {
    return data
  }
};
let newConfig = {
  baseURL: conf.newApi,
  timeout: 60 * 1000, // Timeout
  // withCredentials: true, // Check cross-site Access-Control
  transformRequest(data) {
    return data
  }
};

const _axios = axios.create(config);
const webAxios = axios.create(webconfig)
const newAxios = axios.create(newConfig)

_axios.interceptors.request.use(
  function (config) {
    
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);

webAxios.interceptors.request.use(
  function (config) {
    config.baseURL = conf.webApi + conf.version;


    let ignoJson = false;

		for (let noJSONstrApi of noJSONstrUrl) {
			if (config.url.indexOf(noJSONstrApi) >= 0) {
				ignoJson = true;
				break;
			}
		}
    if (!ignoJson) {
			// console.log("执行到此")
			config.data = JSON.stringify(config.data, {
				indices: false
			});
      config.headers['Content-Type'] = 'application/json'
		}
    return config;
  },
  function (error) {
    // Do something with request error
    return Promise.reject(error);
  }
);
newAxios.interceptors.request.use(
  function (config) {
    if(config.url.startsWith('/api')) {
      config.baseURL = conf.newApi
    }else {
      config.baseURL = conf.newApi + conf.version;
    }

    let ignoJson = false;

		for (let noJSONstrApi of noJSONstrUrl) {
			if (config.url.indexOf(noJSONstrApi) >= 0) {
				ignoJson = true;
				break;
			}
		}
    if (!ignoJson) {
			// console.log("执行到此")
			config.data = JSON.stringify(config.data, {
				indices: false
			});
      config.headers['Content-Type'] = 'application/json'
      const ywxtToken = localStorage.getItem('yw_token');
      config.headers['token'] = ywxtToken;
		}
    return config;
  },
  function (error) {
    return Promise.reject(error);
  }
);

_axios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);

webAxios.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
newAxios.interceptors.response.use(
  function (response) {
    if(response.data.code == 401 && response.data.message=="toke不存在或在其他地方登录，请重新获取！"){
      localStorage.clear();
      sessionStorage.clear();
      window.location.href = "/";
    }
    return response;
  },
  function (error) {
    return Promise.reject(error);
  }
);
let Plugin = {}; //不定义，IE11一下会报错，Plugin 未定义
Plugin.install = function (Vue, options) {
  Vue.axios = _axios;
  window.axios = _axios;

  Vue.webAxios = webAxios;
  window.webAxios = webAxios;

  Vue.newAxios = newAxios;
  window.newAxios = newAxios;

  Object.defineProperties(Vue.prototype, {
    axios: {
      get() {
        return _axios;
      }
    },
    $axios: {
      get() {
        return _axios;
      }
    },
    webAxios: {
      get() {
        return webAxios;
      }
    },
    newAxios: {
      get() {
        return newAxios;
      }
    }
  });
};

Vue.use(Plugin)

export default Plugin;
